export const testimonials = [
  {
    name: "Laura Mitchell, RD",
    role: "Clinical Dietitian · United States",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/bdcf686c-0d32-4aba-a8d8-61e2f3e848fc.jpg",
    quote: "I had GI references spread across three folders and a dozen PDFs. Having physiology, assessment and documentation in separate volumes made it much easier to find what I need before a case discussion.",
  },
  {
    name: "Daniel Ortiz",
    role: "MSc Nutrition Student · Spain",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/6ee00daf-b72c-4659-8d19-c9f1977aa7df.jpg",
    quote: "The hypothetical cases and analysis worksheets gave my study sessions a clear structure. I finally have a consistent way to work through IBS and malabsorption scenarios.",
  },
  {
    name: "Priya Raman",
    role: "Registered Nutritionist · United Kingdom",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/fc131d67-c9e8-4db5-a485-d1f3b19d7bbd.jpg",
    quote: "The Visual Atlas is now my go-to refresher on digestion and absorption, and I adapted the documentation templates to my own workflow in an afternoon. Very well organized for $27.",
  },
];
